var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiemensLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "#41aaaa"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.2 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-path",
    d: "M.5 19.4v-3.8c2.2.7 4.1 1 5.8 1 2.3 0 3.5-.6 3.5-1.8 0-.5-.2-.8-.5-1.2s-1.2-.8-2.7-1.4c-2.6-1-4.2-1.9-5-2.7C.6 8.5.1 7.3.1 5.8c0-1.9.7-3.4 2.2-4.4C3.8.5 5.7 0 8 0c1.3 0 3.1.2 5.6.7v3.7c-1.8-.7-3.5-1.1-5-1.1-2.2 0-3.3.6-3.3 1.8 0 .4.2.8.6 1.1l3 1.5c2.4 1 4 2 4.7 2.7.9.9 1.4 2.1 1.4 3.6 0 2.1-.9 3.7-2.8 4.8-1.5.9-3.4 1.3-5.8 1.3-1.8 0-3.8-.2-5.9-.7zm17.7.3V.3h5.4v19.4h-5.4zm10.4 0V.3h13.9v3.5h-8.7v4.4h7.6v3.2h-7.6V16h8.9v3.7H28.6zm17.7 0V.3h7.1l4.9 12.4 5-12.4H70v19.4h-5.2V6l-5.7 13.9h-3.4L50.1 6v13.7h-3.8zm28.7 0V.3h13.9v3.5h-8.7v4.4h7.6v3.2h-7.6V16h8.9v3.7H75zm17.7 0V.3H99l6.7 13V.3h3.8v19.4h-6.1L96.5 6.6v13.1h-3.8zm20.7-.3v-3.8c2.2.7 4.1 1 5.8 1 2.3 0 3.5-.6 3.5-1.8 0-.5-.2-.8-.5-1.2-.3-.3-1.2-.8-2.7-1.4-2.5-1-4.2-1.9-5-2.7-1-1-1.5-2.2-1.5-3.7 0-1.9.7-3.4 2.2-4.4 1.5-1 3.4-1.5 5.7-1.5 1.3 0 3 .2 5.1.6l.5.1v3.7c-1.8-.7-3.5-1.1-5-1.1-2.2 0-3.3.6-3.3 1.8 0 .4.2.8.6 1.1.3.2 1.4.7 3 1.5 2.4 1 3.9 2 4.7 2.7.9.9 1.4 2.1 1.4 3.6 0 2.1-.9 3.7-2.7 4.8-1.5.9-3.4 1.3-5.8 1.3-2 .1-4-.1-6-.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemensLogo);
export default __webpack_public_path__ + "static/media/siemens_logo.5757e0139e710224777b1f107e44e9a2.svg";
export { ForwardRef as ReactComponent };